import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthLayout } from "../components/AuthLayout";
import { FactSpecimen } from "../components/FactSpecimen";
import { ApiError } from "../api/client";
import { useAuth } from "../auth/AuthContext";

export function LoginPage() {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  async function onSubmit(event: React.FormEvent) {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await auth.signIn(identifier, password);
      const next = (location.state as { from?: string } | null)?.from ?? "/edit";
      navigate(next);
    } catch (err) {
      if (err instanceof ApiError) {
        setError(err.detail);
      } else {
        setError("Couldn't reach the server. Check your connection.");
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthLayout
      left={<FactSpecimen />}
      right={
        <>
          <p className="eyebrow eyebrow-accent rise">01. Returning</p>
          <h1 className="rise d1 mt-3 mb-7 text-5xl tracking-tight">Welcome back.</h1>

          <form className="rise d2 space-y-5" onSubmit={onSubmit}>
            <div>
              <label htmlFor="identifier" className="field-label">
                Username or email
              </label>
              <input
                id="identifier"
                type="text"
                autoFocus
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                className="field-input"
                required
              />
            </div>

            <div>
              <div className="flex items-baseline justify-between">
                <label htmlFor="password" className="field-label">
                  Password
                </label>
                <Link
                  to="/reset-password"
                  className="font-body text-xs text-terra hover:text-terra-deep"
                >
                  Forgot?
                </Link>
              </div>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="field-input"
                required
              />
            </div>

            {error && (
              <p className="rounded border border-plum/30 bg-plum/[0.04] px-3 py-2 text-sm text-plum">
                {error}
              </p>
            )}

            <button type="submit" className="btn btn-primary w-full" disabled={submitting}>
              {submitting ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <p className="rise d3 mt-7 text-sm text-ink-mute">
            New here?{" "}
            <Link to="/signup" className="uline">
              Create your card
            </Link>
            .
          </p>

          <hr className="my-9 border-t border-rule" />
          <p className="eyebrow rise d4 opacity-70">
            Migrated from Mobilocard · your old password still works
          </p>
        </>
      }
    />
  );
}
